import styled from "styled-components";

export default function MainBannerBlock({ children }) {
  return (
    <Block>{children}</Block>
  )
}

const Block = styled.div`
  height: 100%;
`;